"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireWildcard(require("react"));
var _Title = _interopRequireDefault(require("../../Title"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __spreadArrays = void 0 && (void 0).__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
  return r;
};
/* eslint-disable no-param-reassign */
/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/naming-convention */

var BuyNowComponent = function BuyNowComponent(props) {
  var flexTitle = props.flexTitle,
    desc = props.desc,
    configuration = props.configuration,
    style = props.style,
    onCallback = props.onCallback,
    buyType = props.buyType,
    typeArr = props.typeArr,
    layoutMode = props.layoutMode,
    colorTheme = props.colorTheme;
  var _a = (0, _react.useState)([]),
    asyncompatibleArr = _a[0],
    setAsynCompatibleArr = _a[1];
  var layoutNum = layoutMode ? 3 : 4;
  var compatibleArr = configuration && configuration.length % layoutNum ? __spreadArrays(configuration, new Array(layoutNum - configuration.length % layoutNum).fill({
    supplement: true
  })) : configuration;
  var buyCon = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (buyCon === null || buyCon === void 0 ? void 0 : buyCon.current) {
      var buyConList = buyCon.current.childNodes;
      buyConList.forEach(function (item) {
        var buyConcurrent = item.getBoundingClientRect().height;
        item.childNodes[0].style.minHeight = buyConcurrent + "px";
      });
    }
  }, [asyncompatibleArr]);
  (0, _react.useEffect)(function () {
    if (compatibleArr) {
      if (typeArr === null || typeArr === void 0 ? void 0 : typeArr.includes('all')) {
        setAsynCompatibleArr(compatibleArr);
        return;
      }
      var compatibleArrNew = compatibleArr === null || compatibleArr === void 0 ? void 0 : compatibleArr.filter(function (item) {
        return typeArr === null || typeArr === void 0 ? void 0 : typeArr.includes(item.type);
      });
      compatibleArrNew = compatibleArrNew.length % layoutNum ? __spreadArrays(compatibleArrNew, new Array(layoutNum - compatibleArrNew.length % layoutNum).fill({
        supplement: true
      })) : compatibleArrNew;
      // console.log(compatibleArrNew, 'compatibleArrNew');
      setAsynCompatibleArr(compatibleArrNew);
    }
  }, [typeArr]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-buy-now-default-container-bp',
    style: (0, _typeof2["default"])(style) === 'object' ? style : buyType === 'yellow' ? {
      paddingBottom: 0
    } : colorTheme === 'gradient' ? {
      paddingBottom: 40,
      background: '#F1F6FA'
    } : {}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-buy-now-default-container__children'
  }, /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    desc: desc,
    title: flexTitle
  }), /*#__PURE__*/_react["default"].createElement("section", {
    className: (0, _classnames["default"])('flex-buy-now-default-container__children__container', {
      'flex-buy-now-default-container__children__container--yellow': buyType === 'yellow'
    }),
    ref: buyCon
  }, !typeArr && compatibleArr && compatibleArr.map(function (item, index) {
    var _a = item || {},
      title = _a.title,
      supplement = _a.supplement,
      duration = _a.duration,
      backgroundUrl = _a.backgroundUrl,
      text_list = _a.text_list,
      content = _a.content,
      but_txt = _a.but_txt,
      but_href = _a.but_href,
      tagTxt = _a.tagTxt,
      extendProps = _a.extendProps;
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: index,
      className: (0, _classnames["default"])('flex-buy-now-default-container__children__container__list__container', {
        'flex-buy-now-default-container__children__container__list__container--mobile': supplement && buyType === 'yellow',
        'flex-buy-now-default-container__children__container__list__container--yellow': buyType === 'yellow',
        'flex-buy-now-default-container__children__container__list__container--mobile--typearr': supplement && buyType !== 'yellow',
        'flex-buy-now-default-container__children__container__list__container--gradient': colorTheme === 'gradient',
        'flex-buy-now-default-container__children__container__list__container--purple': colorTheme === 'purple'
      }),
      style: layoutMode ? {
        minWidth: '30%',
        maxWidth: '33%'
      } : {}
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('flex-buy-now-default-container__children__container__list', {
        noborderTop: colorTheme === 'gradient' || colorTheme === 'purple'
      }),
      style: backgroundUrl ? {
        backgroundImage: "url(" + backgroundUrl + ")"
      } : {}
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('list__head', {
        list__head_gradient: colorTheme === 'gradient',
        list__head_purple: colorTheme === 'purple'
      })
    }, /*#__PURE__*/_react["default"].createElement("a", {
      href: but_href ? but_href : 'javascript:void(null);'
    }, /*#__PURE__*/_react["default"].createElement("h3", {
      className: (0, _classnames["default"])('list__title', {
        'list__title--yellow': buyType === 'yellow',
        'list__title--gradient': colorTheme === 'gradient',
        'list__title--purple': colorTheme === 'purple'
      })
    }, ' ', title))), /*#__PURE__*/_react["default"].createElement("div", {
      className: 'list__duration'
    }, duration), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        minHeight: '84px'
      }
    }, text_list === null || text_list === void 0 ? void 0 : text_list.map(function (item, index) {
      var _a = item || {},
        title = _a.title,
        text = _a.text;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: 'list__text_list',
        key: index
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: 'list__text_list_title'
      }, title), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('list__text_list_text', {
          'no-title': !title
        })
      }, text));
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('list__description', {
        'layout-three': layoutMode
      })
    }, /*#__PURE__*/_react["default"].createElement("div", {
      dangerouslySetInnerHTML: {
        __html: content || ''
      }
    })), onCallback ? (/*#__PURE__*/_react["default"].createElement("div", __assign({
      className: 'list__a',
      onClick: function onClick() {
        onCallback(item);
      }
    }, extendProps || {}), /*#__PURE__*/_react["default"].createElement("div", {
      className: 'but_href_a'
    }, but_txt))) : (/*#__PURE__*/_react["default"].createElement("div", {
      className: 'list__a'
    }, /*#__PURE__*/_react["default"].createElement("a", __assign({
      href: but_href ? but_href : 'javascript:void(null);'
    }, extendProps || {}), but_txt)))), tagTxt ? (/*#__PURE__*/_react["default"].createElement("div", {
      className: 'special-tag'
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: (0, _classnames["default"])('special-tag-txt', {
        'special-tag-txt-purple': colorTheme === 'purple'
      })
    }, tagTxt))) : null);
  }), typeArr && asyncompatibleArr && asyncompatibleArr.map(function (item, index) {
    var _a = item || {},
      title = _a.title,
      supplement = _a.supplement,
      duration = _a.duration,
      backgroundUrl = _a.backgroundUrl,
      text_list = _a.text_list,
      content = _a.content,
      but_txt = _a.but_txt,
      but_href = _a.but_href,
      tagTxt = _a.tagTxt,
      extendProps = _a.extendProps;
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: index,
      className: (0, _classnames["default"])('flex-buy-now-default-container__children__container__list__container', {
        'flex-buy-now-default-container__children__container__list__container--mobile--typearr': supplement,
        'flex-buy-now-default-container__children__container__list__container--yellow': buyType === 'yellow'
      }),
      style: layoutMode ? {
        minWidth: '30%',
        maxWidth: '33%'
      } : {}
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'flex-buy-now-default-container__children__container__list',
      style: backgroundUrl ? {
        backgroundImage: "url(" + backgroundUrl + ")"
      } : {}
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'list__head'
    }, /*#__PURE__*/_react["default"].createElement("a", {
      href: but_href ? but_href : 'javascript:void(null);'
    }, /*#__PURE__*/_react["default"].createElement("h3", {
      className: (0, _classnames["default"])('list__title', {
        'list__title--yellow': buyType
      })
    }, ' ', title)), tagTxt ? (/*#__PURE__*/_react["default"].createElement("div", {
      className: 'special-tag'
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: (0, _classnames["default"])('special-tag-txt', {
        'special-tag-txt-student': colorTheme === 'gradient'
      })
    }, tagTxt))) : null), /*#__PURE__*/_react["default"].createElement("div", {
      className: 'list__duration'
    }, duration), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        minHeight: '84px'
      }
    }, text_list === null || text_list === void 0 ? void 0 : text_list.map(function (item, index) {
      var _a = item || {},
        title = _a.title,
        text = _a.text;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: 'list__text_list',
        key: index
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: 'list__text_list_title'
      }, title), /*#__PURE__*/_react["default"].createElement("div", {
        className: 'list__text_list_text'
      }, text));
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: 'list__description',
      dangerouslySetInnerHTML: {
        __html: content || ''
      }
    }), onCallback ? (/*#__PURE__*/_react["default"].createElement("div", __assign({
      className: 'list__a',
      onClick: function onClick() {
        onCallback(item);
      }
    }, extendProps || {}), /*#__PURE__*/_react["default"].createElement("div", {
      className: 'but_href_a'
    }, but_txt))) : (/*#__PURE__*/_react["default"].createElement("div", {
      className: 'list__a'
    }, /*#__PURE__*/_react["default"].createElement("a", __assign({
      href: but_href ? but_href : 'javascript:void(null);'
    }, extendProps || {}), but_txt)))));
  }))));
};
BuyNowComponent.displayName = 'TCIBuyNowComponent';
var _default = exports["default"] = BuyNowComponent;